import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { QueryParametersService } from "./ip-query-parameter.service";
import { IPagination } from "src/app/shared/models/pagination";
import { Observable, tap } from "rxjs";
import { PageResponse } from "../interfaces/ip-page-response";
import { IpPayInRequest, IpPayInResponse } from "../interfaces/ip-pay-in-response";
import { SalePayInRequest } from "../interfaces/ip-sale-pay-in-request";
import SettlementSaleResponse from "../interfaces/ip-settlement-sale-response";
import PaymentsCreatedFromCsvResponse from "../interfaces/ip-payments-created-from-csv-response";
import { WrongfullyCreatedPaymentResponse } from "../interfaces/ip-wrongfully-created-sale-response";

@Injectable({
  providedIn: 'root',
})
export class IpPayInService {
  api = environment.api;

  constructor(
    private http: HttpClient,
    private queryParameterService: QueryParametersService
  ) {}
 
  getPayIn(
    pagination: IPagination,
    startDate: string,
    endDate: string,
    conciliated: boolean,
    originOwner?: string,
    originBank?: string
  ): Observable<PageResponse<IpPayInResponse>> {
    let params = this.queryParameterService.buildQueryParameters(
      '',
      '',
      pagination,
      '',
      ''
    );

    if (startDate && startDate.trim() !== '') {
      params = params.set('startDate', startDate);
    }
    if (endDate && endDate.trim() !== '') {
      params = params.set('endDate', endDate);
    }
    if (conciliated !== null) {
      params = params.set('conciliated', conciliated);
    }
    if (originOwner && originOwner.trim() !== '') {
      params = params.set('originOwner', originOwner);
    }
    if (originBank && originBank.trim() !== '') {
      params = params.set('originBank', originBank);
    }
    return this.http.get<PageResponse<IpPayInResponse>>(
      this.api + '/invopay/pay-in',
      { params }
    );
  }  
  
  getPaymentsToConciliate(
    startDate?: string,
    endDate?: string,
    conciliated?: boolean,
    saleAmount?: number,
    saleCurrency?: string
  ): Observable<IpPayInResponse[]> {
    let params = new HttpParams()
    if (startDate && startDate.trim() !== '') {
      params = params.set('startDate', startDate);
    }
    if (endDate && endDate.trim() !== '') {
      params = params.set('endDate', endDate);
    }
    if (conciliated !== null && conciliated !== undefined) {
      params = params.set('conciliated', conciliated);
    }
    if (saleCurrency && saleCurrency.trim() !== '') {
      params = params.set('currency', saleCurrency);
    }
    if (saleAmount !== null && saleAmount !== undefined) {
      params = params.set('saleAmount', saleAmount);
    }
    return this.http.get<IpPayInResponse[]>(
      this.api + '/invopay/pay-in/get-conciliate',
      { params }
    );
  }  

  createPaymentsFromCsv(csvFile: File): Observable<PaymentsCreatedFromCsvResponse> {
    const formData = new FormData();
    formData.append("payInCsvFile", csvFile);
    return this.http.post<PaymentsCreatedFromCsvResponse>(`${this.api}/invopay/pay-in/fromCsv`, formData)
    .pipe(
      tap(value => value.wrongfullyCreatedPaymentsMap = this.fromSimpleMapToTypedMap(value.wrongfullyCreatedPaymentsMap as unknown as { [key: string]: WrongfullyCreatedPaymentResponse }))
    );
  }
  
  createPayIn(
    payIn: IpPayInRequest
  ): Observable<IpPayInResponse> {
    return this.http.post<IpPayInResponse>(
      this.api + '/invopay/pay-in',
      payIn
    );
  }  
  
  editPayIn(
    payIn: IpPayInRequest, 
    id: string
  ): Observable<IpPayInResponse> {
    return this.http.put<IpPayInResponse>(
      this.api + `/invopay/pay-in/${id}`,
      payIn
    );
  }  

  conciliatePayIn(
    salePayInRequest: SalePayInRequest,
    payId: string
  ): Observable<IpPayInResponse> {
    return this.http.put<IpPayInResponse>(
      this.api + `/invopay/pay-in/conciliate/${payId}`,
      salePayInRequest
    );
  }

  getPayInSales(payId:string): Observable<SettlementSaleResponse[]>{
    return this.http.get<SettlementSaleResponse[]>(
      this.api + `/invopay/pay-in/sales/${payId}`,
    )
  }

  private fromSimpleMapToTypedMap(simpleMap: { [key: string]: WrongfullyCreatedPaymentResponse }): Map<string, WrongfullyCreatedPaymentResponse> {
      const resultMap = new Map<string, WrongfullyCreatedPaymentResponse>();
      for (const key in simpleMap) {
        if (simpleMap.hasOwnProperty(key)) {
          resultMap.set(key, simpleMap[key]);
        }
      }
      return resultMap;
    }

}